import { requestApi } from '../util/network'

// 盲盒
export const getBoxListGobuy =
    (params) =>
        requestApi(
            '/box/box_list',
            'POST',
            params,
            'member'
        )

// 盲盒info
export const getBoxNewInfo =
    (params) =>
        requestApi(
            '/box/box_now_info',
            'POST',
            params,
            'member'
        )

// 盲盒info
export const getBoxInfo =
    (params) =>
        requestApi(
            '/box/box_info',
            'POST',
            params,
            'member'
        )

// 购买盲盒
export const getBuyBox =
    (params) =>
        requestApi(
            '/box/buy_box',
            'POST',
            params,
            'member'
        )

// 倒计时结束开盲盒
export const getBoxLastInfo =
    (params) =>
        requestApi(
            '/box/box_last_info',
            'POST',
            params,
            'member'
        )
